const baseStyle = {
  chat: { flexDirection: 'column', w: '100%', height: '100%' },
  messages: { flexDirection: 'column', overflowY: 'auto', position: 'relative', w: '100%' },
  suggestions: { display: 'block', textAlign: 'right', width: '100%' },
}

const defaultProps = {}

const sizes = {}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
